import { omniaResolve } from "@omnia/shared/promises"
import { ImportDocument, IOmniaSession, IOmniaSettings, OmniaModuleId } from "../omnia"
import { IDatalayersService } from "../types"
import { IGeorefLayerUpateModel, IGeorefReprojectedImage, IGeorefReprojectionModel, IGeorefService, IGeorefSourceImage } from "./types"

export class GeorefService extends omnia.OmniaService implements IGeorefService {

    static $inject = ["$q", "OmniaSession", "OmniaDatalayersService"]

    private _settings: IOmniaSettings

    constructor(private $q: ng.IQService, session: IOmniaSession, layerSvc: IDatalayersService) {

        super(
            session,
            {
                module: OmniaModuleId.Layers,
                name: "GeorefService",
                dependencies: [
                    layerSvc
                ]
            }
        )

        this._settings = session.getSettings("maplayers.georef")

    }

    getRefreshPromise() {
        return omniaResolve()
    }

    getSourceImageFromImportdoc(doc: ImportDocument): IGeorefSourceImage {

        let img: IGeorefSourceImage = {
            Id: doc.ImportDocumentId,
            Description: doc.Description || doc.FileName,
            Path: doc.FilePath,
            Width: doc.ImageWidth,
            Height: doc.ImageHeight
        }

        return img

    }

    getSourceImageInfo(id: number): ng.IPromise<IGeorefSourceImage> {
        let url = `/api/import/document/get/?id=${id}`
        return this.get<ImportDocument>(url).then(r => this.getSourceImageFromImportdoc(r))
    }


    getImageUrl(path: string): string {
        path = encodeURIComponent(path)
        return `${this.ohttp.getApiBaseUrl()}/api/img/?path=${path}`
    }


    private getStateKey(fieldId: number, docId: number): string {
        return `state.field${fieldId},doc${docId}`
    }

    getState(fieldId: number, docId: number): IGeorefReprojectionModel {
        let key = this.getStateKey(fieldId, docId)
        return this._settings.get(key)
    }

    saveState(fieldId: number, docId: number, state: IGeorefReprojectionModel) {
        let key = this.getStateKey(fieldId, docId)
        this._settings.set(key, state)
    }

    clearState(fieldId: number, docId: number) {
        let key = this.getStateKey(fieldId, docId)
        this._settings.set(key, undefined)
    }


    getImageElementFromImportDocument(doc: IGeorefSourceImage): ng.IPromise<HTMLImageElement> {

        let url = this.getImageUrl(doc.Path)

        let defer = this.$q.defer<HTMLImageElement>()

        let img = new Image()

        img.onload = () => {
            defer.resolve(img)
        }

        img.src = url

        return defer.promise


    }

    reprojectImage(model: IGeorefReprojectionModel): ng.IPromise<IGeorefReprojectedImage> {

        let url = "/api/map/georef/reproject"

        return this.ohttp.post(url, model).then(r => {

            let rawData: {
                Extent: number[],
                ImageMimeType: string,
                ImageData: string
            } = r.data

            let extent = rawData.Extent

            let dataUrl = "data:" + rawData.ImageMimeType + ";base64," + rawData.ImageData

            return {
                extent: extent,
                imageMimeType: rawData.ImageMimeType,
                imageUrl: dataUrl
            }

        })

    }

    saveLayer(model: IGeorefLayerUpateModel): ng.IPromise<number> {
        const url = "/api/map/georef/layers/save"
        return this.post(url, model)
    }

    deleteLayer(id: number): ng.IPromise<any> {
        const url = `/api/map/georef/layers/delete?id=${id}`
        return this.delete(url).then(r => r.data)
    }

}
